export default __webpack_public_path__ + "static/media/05.ac694631.png";